<template>
  <div class="h-100 d-flex flex-column" @dragover.prevent @drop.prevent="fileDropHandler">

    <div class="py-2 px-4 bottom-border">
      <div class="d-flex align-items-center">
        <div class="flex-grow-1 mr-2" style="font-size: 18px">
          <input type="text" v-model="task.task_name" class="form-control-title w-100 pl-0" @change="saveTask">
        </div>
        <a style="font-size: 20px" class="mr-3" href="javascript:;" @click="toggleRead"><i :class="task.task_read ? 'fa fa-envelope-open' : 'fa fa-envelope'"></i></a>
        <a style="font-size: 20px" class="font-red mr-3" href="javascript:;" @click="deleteTaskAsk"><i class="fa fa-trash"></i></a>
        <a style="font-size: 20px" href="javascript:;" @click="closeTask"><i class="fa fa-times"></i></a>
      </div>

      <div class="d-flex w-100 mt-1">
        <div class="text-left">

          <div class="mt-1" style="font-size: 16px" v-if="task.task_deadline_date != null">
            <b>NB de jours avant échéance</b>: {{daysBeforeDeadline}}
          </div>

          <div class="mt-1" style="font-size: 16px" v-if="task.task_deadline_date != null">
            <b>Date d'échéance</b>: {{task.task_deadline_date}}
          </div>

          <hr class="my-2" style="border-top: 1px solid #aaa;" v-if="task.task_deadline_date != null">

          <div class="mt-1 position-relative">
            <span v-if="task.project_name != null"><b>Projet</b>: <a :href="projectLink">{{task.project_number}} • {{task.project_name}}</a></span>
            <span v-else><b>Projet</b>: <em><a href="javascript:;" @click="">(non défini)</a></em></span>
            <div class="position-absolute" style="top: 30px; left: 0;">
              <!-- Sélectionner le projet s'il n'est pas déjà sélectionné. -->
            </div>
          </div>

          <div class="mt-1">
            <b>Chargé de projet du client</b>: {{task.project_project_manager_contact_name}}
          </div>

          <div class="mt-1">
            <b>Responsable du projet</b>: {{task.project_user_name}}
          </div>

          <div class="mt-1">
            <b>Crée par</b>: {{task.user_name}}
          </div>

          <div class="mt-1">
            <b>Crée le</b>: {{longTimestamp(task.task_creation_datetime)}}
          </div>

        </div>
        <div class="text-right flex-grow-1">

          <div class="d-flex w-100">
            <label style="line-height: 30px;" class="my-0 mr-1 text-right flex-grow-1">Date début:</label>
            <date-picker :size="'small'" v-model="task.task_start_date" @change="startDateChanged" />
          </div>

          <div class="d-flex w-100 mt-1">
            <label style="line-height: 30px;" class="my-0 mr-1 text-right flex-grow-1">Date d'échéance:</label>
            <date-picker :size="'small'" v-model="task.task_deadline_date" @change="deadlineDateChanged" />
          </div>

          <div class="d-flex w-100 mt-1">
            <label style="line-height: 30px;" class="my-0 mr-1 text-right flex-grow-1">Date rappel:</label>
            <date-picker :size="'small'" v-model="task.task_remind_date" @change="saveTask" />
          </div>

          <div class="d-flex w-100 mt-1">
            <label style="line-height: 30px;" class="my-0 mr-1 text-right flex-grow-1">% avancement:</label>
            <input type="number" class="form-control input-sm input-xsmall" v-model="task.task_progress" @change="saveTask" >
          </div>

        </div>
      </div>


    </div>

    <div class="d-flex bottom-border">

      <!-- État de la tâche. -->
      <div style="border-right: 1px solid #ccc">
        <div style="width: 5px"></div>
        <div class="p-0">
          <select class="form-control" style="border: none; min-width: 125px" v-model="task.task_state_id" @change="saveTask">
            <option v-for="(state, index) in states" :key="index" :value="state.task_state_id">{{state.task_state_name}}</option>
          </select>
        </div>
      </div>
      
      <!-- Utilisateurs assignés -->
      <div style="padding: 2px;" class="flex-grow-1">
        <div v-for="(assignee, index) in task.assignees" :key="index" class="task-assignee" :style="{backgroundColor: assignee.user_background_color}">
          <span>{{assignee.user_name}}</span> <a href="javascript:;" class="task-assignee-delete" @click="unassignUser(assignee, 'assignee')"><i class="fa fa-times"></i></a>
        </div>
        <div class="task-assignee task-assignee-add" @click="showAddAssigneeSelect">
          <i class="fa fa-plus"></i>
        </div>
      </div>

      <div style="padding: 2px 15px;">
        <button class="btn btn-sm" :class="{'green': historyToggled}" @click="historyToggled = !historyToggled">Historique</button>
      </div>

    </div>

    <div class="d-flex bottom-border">

      <div style="border-right: 1px solid #ccc; min-width: 126px; font-size: 12px" class="text-right">
        <div style="padding: 6px 2px 0 0">Liste de distribution:</div>
      </div>
      
      <!-- Utilisateurs de la liste de distribution -->
      <div style="padding: 2px;" class="flex-grow-1">
        <div v-for="(distributor, index) in task.distributors" :key="index" class="task-assignee" :style="{backgroundColor: distributor.user_background_color}">
          <span>{{distributor.user_name}}</span> <a href="javascript:;" class="task-assignee-delete" @click="unassignUser(distributor, 'distributor')"><i class="fa fa-times"></i></a>
        </div>
        <div class="task-assignee task-assignee-add" @click="showAddDistributorSelect">
          <i class="fa fa-plus"></i>
        </div>
      </div>

    </div>

    <div style="overflow-y: auto;" class="flex-grow-1" ref="scrollable-content" v-if="!historyToggled">
      <div>
        <quill 
          ref="quill-editor" 
          class="h-100" 
          v-model="task.task_description" 
          @change="saveTask" 
          :uploadHander="handleFileUploadFromDrop" 
          :showToolbar="true"
          :allowDragAndDrop="true"
          :allowImages="true"
          :hasEmojis="false"
        />
      </div>

      <div class="task-manager-files-section position-relative">
        <div class="text-center" style="position: absolute; top: -10px; left: 0; width: 100%; font-size: 12px;">
          <span style="background-color: white;" class="px-1">Fichiers ({{task.files.length}})</span>
        </div>

        <div class="my-2">
          <a v-for="(file, index) in task.files" :key="index" :href="filePreviewLink(file)" target="_blank" class="task-manager-wrapper">
            <div class="task-manager-file">

              <div class="task-manager-file-thumbnail">
                <fancy-box v-if="isFileImage(file)" :href="fileAttachmentImage(file)" style="width: 100%; height: 100%">
                  <img :src="fileAttachmentThumbnail(file)" alt="" style="width: 100%; height: 100%; object-fit: contain">
                </fancy-box>
                <a v-else-if="isFilePdf(file) || isFileText(file)" :href="filePreviewLink(file)" target="_blank" style="width: 100%; height: 100%; display: block">
                  <img :src="fileAttachmentThumbnail(file)" alt="" style="width: 100%; height: 100%; object-fit: contain">
                </a>
                <a v-else href="javascript:;" @click="downloadFile(file)" style="width: 100%; height: 100%; display: block">
                  <img :src="fileAttachmentThumbnail(file)" alt="" style="width: 100%; height: 100%; object-fit: contain">
                </a>
              </div>

              <div class="flex-grow-1 h-100">
                <div class="bold">{{file.task_file_title}}</div>
                <div>
                  <span class="font-grey-gallery mr-2">{{shortTimestamp(file.task_file_attachment_datetime)}}</span>
                  <span>
                    <a href="javascript:;" @click="downloadFile(file)">Télécharger</a> - 
                    <a href="javascript:;" @click="deleteFileAsk(file, $event)" class="font-red">Supprimer</a>
                  </span>
                </div>
              </div>
            </div>
          </a>
        </div>

        <div class="my-2">
          <button class="btn blue" @click="triggerFileUploadClick">Télécharger un fichier</button>
        </div>

      </div>

      <div class="task-manager-comment-section position-relative">
        <div class="text-center" style="position: absolute; top: -10px; left: 0; width: 100%; font-size: 12px;">
          <span style="background-color: white;" class="px-1">Commentaires (Affichage {{task.loaded_comment_count}} / {{task.total_comments}})</span>
        </div>
        <div v-if="fetchingComments">
          <div class="text-center p-3 font-grey-gallery">Obtention des commentaires...</div>
        </div>

        <div v-if="task.comments.length == 0 && !fetchingComments">
          <div class="text-center p-3 font-grey-gallery">Aucun commentaires à afficher</div>
        </div>
        <div v-else>
          <div v-if="canLoadMore" class="text-center px-2 pb-2 pt-3">
            <a href="javascript:;" @click="loadMoreComments">Charger plus de commentaires</a>
          </div>
          
          <feed-message v-for="(message, index) in reversedComments" :key="index"
            :message="message"
            fileAttachmentImageUrl="task/files/%fileid%/image"
            fileAttachmentThumbnailUrl="task/files/%fileid%/thumbnail"
            fileAttachmentDownloadUrl="task/files/%fileid%/download"
            @resendMessage="submitComment($event, true)"
            @deleteMessage="deleteComment"
          />

        </div>
      </div>

    </div>
    <div style="overflow-y: auto;" class="flex-grow-1 pb-3" ref="scrollable-content" v-else>

      <div class="task-manager-comment-section position-relative">

        <div v-if="fetchingHistory">
          <div class="text-center p-3 font-grey-gallery">Chargement de l'historique...</div>
        </div>

        <div v-if="task.history.length == 0 && !fetchingHistory">
          <div class="text-center p-3 font-grey-gallery">L'historique est vide</div>
        </div>
        <div v-else>
          <div v-if="canLoadMore" class="text-center px-2 pb-2 pt-3">
            <a href="javascript:;" @click="loadMoreHistory">Charger plus d'éléments</a>
          </div>
          <div v-for="(history, index) in reversedHistory" :key="index" class="task-manager-comment" :class="{'my-comment': isMyHistory(history)}">
            <div class="avatar" :style="{backgroundColor: history.history_user_background_color}"> {{history.history_user_initials}} </div>
            <div class="content-wrapper mx-2 position-relative">

              <div class="px-3 pt-2">
                <b>{{history.history_user_name}}</b> &nbsp; <span style="color: #777">{{shortTimestamp(history.history_datetime)}}</span>
              </div>
              <div class="px-3 pb-2 pt-1">

                <table class="mt-2" v-if="history.history_type == '1'">
                  <tbody>
                    <tr>
                      <td colspan="2" class="bold underline font-blue">Création/Ajout</td>
                    </tr>
                    <tr v-for="(history_detail, index2) in history.details" :key="`${index}-${index2}-0`">
                      <td style="vertical-align: top" class="bold pr-2">{{__("audit_detail_"+history_detail.audit_field)}}:</td>
                      <td v-if="history_detail.audit_new_value != '' && history_detail.audit_new_value != null" style="vertical-align: top" v-html="history_detail.audit_new_value"></td>
                      <td v-else class="italic font-grey-gallery">(vide)</td>
                    </tr>
                  </tbody>
                </table>

                <table class="mt-2" v-else-if="history.history_type == '2'">
                  <tbody>

                    <tr>
                      <td colspan="2" class="bold underline">Avant</td>
                    </tr>
                    <tr v-for="(history_detail, index2) in history.details" :key="`${index}-${index2}-1`">
                      <td style="vertical-align: top" class="bold pr-2">{{__("audit_detail_"+history_detail.audit_field)}}:</td>
                      <td v-if="history_detail.audit_old_value != '' && history_detail.audit_old_value != null" style="vertical-align: top" v-html="history_detail.audit_old_value"></td>
                      <td v-else class="italic font-grey-gallery">(vide)</td>
                    </tr>

                    <tr>
                      <td colspan="2" class="bold underline pt-2">Après</td>
                    </tr>
                    <tr v-for="(history_detail, index2) in history.details" :key="`${index}-${index2}-2`">
                      <td style="vertical-align: top" class="bold pr-2">{{__("audit_detail_"+history_detail.audit_field)}}:</td>
                      <td v-if="history_detail.audit_new_value != '' && history_detail.audit_new_value != null" style="vertical-align: top" v-html="history_detail.audit_new_value"></td>
                      <td v-else class="italic font-grey-gallery">(vide)</td>
                    </tr>

                  </tbody>
                </table>

                <table class="mt-2" v-else-if="history.history_type == '3'">
                  <tbody>
                    <tr>
                      <td colspan="2" class="bold underline font-red">Suppression</td>
                    </tr>
                    <tr v-for="(history_detail, index2) in history.details" :key="`${index}-${index2}-3`">
                      <td class="bold pr-2">{{__("audit_detail_"+history_detail.audit_field)}}:</td>
                      <td v-if="history_detail.audit_old_value != '' && history_detail.audit_old_value != null" v-html="history_detail.audit_old_value"></td>
                      <td v-else class="italic font-grey-gallery">(vide)</td>
                    </tr>
                  </tbody>
                </table>

              </div>

            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="task-manager-compose-comment" v-if="!historyToggled">
      <div class="avatar" :style="{backgroundColor: user.user_background_color}"> {{user.user_initials}} </div>
      <div class="ml-2 flex-grow-1 position-relative">
        <fancy-textarea-box 
          ref="comment-box" 
          v-model="current_comment" 
          @enterPressed="sendComment" 
          @toolClick="toolClick"
        />
      </div>
    </div>

    <div class="task-manager-fixed-container" v-if="showAddAssigneeContainer" @click="showAddAssigneeContainer = false">
      <div @click.stop="" style="width: 175px" ref="add-assignee-container">
        <select2 
          class="mx-1" 
          placeholder="Choisir un utilisateur" 
          ref="add-assignee-select" 
          :endpoint="userSelect2Endpoint" 
          @selected="addAssigneeSelected($event, 'assignee')" 
          :dropdownParent="'.task-manager-fixed-container'" 
          :attributes="{task_id: task.task_id}"
        />
      </div>
    </div>

    <div class="task-manager-fixed-container" v-if="showAddDistributorContainer" @click="showAddDistributorContainer = false">
      <div @click.stop="" style="width: 175px" ref="add-distributor-container">
        <select2 
          class="mx-1" 
          placeholder="Choisir un utilisateur" 
          ref="add-distributor-select" 
          :endpoint="userSelect2Endpoint" 
          @selected="addAssigneeSelected($event, 'distributor')" 
          :dropdownParent="'.task-manager-fixed-container'" 
          :attributes="{task_id: task.task_id}"
        />
      </div>
    </div>

    <div class="task-manager-fixed-container" v-if="showSetCategoryContainer" @click="showSetCategoryContainer = false">
      <div @click.stop="" style="width: 175px; background-color: white; border-radius: 11px;" ref="set-category-container">
        <div v-for="(category, index) in categories" :key="index" class="py-1">
          <div class="py-1 px-3 text-center clickable" style="border-radius: 100px; white-space: nowrap;" :style="{color: category.task_category_font_color, backgroundColor: category.task_category_background_color}" @click="changeTaskCategory(category)">
            {{category.task_category_name}}
          </div>
        </div>
      </div>
    </div>

    <div class="position-absolute" style="opacity: 0; pointer-events: none">
      <input type="file" ref="task-file-upload" multiple @change="handleFileUploadFromInput">
    </div>

  </div>
</template>

<script>
import Select2 from '../Select2.vue';
import Quill from './Quill.vue';
//import bootbox from 'bootbox';
import FancyBox from '../FancyBox.vue'
import DatePicker from '../DatePicker.vue'
import FancyTextareaBox from '../FancyTextareaBox.vue';
import FeedMessage from '../messagefeed/FeedMessage.vue';

export default {
  components: { Quill, Select2, FancyBox, DatePicker, FancyTextareaBox, FeedMessage },
  name: "task-details",
  props: {
    task: {
      type: Object,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    states: {
      type: Array,
      required: true
    },
    categories: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      current_comment: "",
      fetchingComments: false,
      fetchingHistory: false,
      showAddDistributorContainer: false,
      showAddAssigneeContainer: false,
      showSetCategoryContainer: false,
      historyToggled: false
    }
  },
  watch: {
    async historyToggled(val) {
      if(val){
        this.loaded_history_count = 10;
        await this.loadMoreHistory();
        this.$nextTick(() => {
          this.$refs["scrollable-content"].scrollTo({
            top: this.$refs["scrollable-content"].scrollHeight
          })
        })
      }
      window.applyAdvancedFormatDetails();
    }
  },
  computed: {
    shortTimestamp() {
      return (date) => {
        return moment(date).format("DD MMM à HH:mm");
      }
    },
    longTimestamp() {
      return (date) => {
        return moment(date).format("DD MMM YYYY à HH:mm");
      }
    },
    daysBeforeDeadline() {
      return moment(this.task.task_deadline_date).diff(moment(), 'days')+1;
    },
    isMyHistory() {
      return (history) => {
        return history.history_user_id == this.user.user_id;
      }
    },
    reversedComments() {
      return this.task.comments.slice().reverse().map((msg) => ({
        sending_error: msg.sending_error,
        message_id: msg.task_comment_id,
        message_creation_datetime: msg.task_comment_creation_datetime,
        message_content: msg.task_comment_text,
        message_type: '1',
        user_background_color: msg.user_background_color,
        user_initials: msg.user_initials,
        user_name: msg.user_name,
        files: msg.files.map((f) => ({
          file_id: f.task_file_id,
          file_title: f.task_file_title,
          file_mime: f.task_file_mime
        })),
        is_mine: msg.task_comment_user_id == this.user.user_id,
        original: msg
      }));
    },
    reversedHistory() {
      return this.task.history.slice().reverse();
    },
    canLoadMore() {
      return this.task.total_comments > this.task.loaded_comment_count;
    },
    userSelect2Endpoint() {
      return `${window.baseUrl}task/select2/task_user_id`;
    },
    projectLink() {
      return `${window.baseUrl}project/view/${this.task.task_project_id}`
    },
    fileAttachmentImage() {
      return (file) => {
        return `${window.baseUrl}task/files/${file.task_file_id}/image`
      }
    },
    fileAttachmentThumbnail() {
      return (file) => {
        if(file.task_file_id === null){
          return `${window.baseUrl}assets/global/img/loading.gif`
        } else {
          return `${window.baseUrl}task/files/${file.task_file_id}/thumbnail`
        }
      }
    },
    isFilePdf() {
      return (file) => {
        if(file.task_file_mime === undefined) return false;
        return file.task_file_mime === "application/pdf";
      }
    },
    isFileText() {
      return (file) => {
        if(file.task_file_mime === undefined) return false;
        return file.task_file_mime.indexOf("text/") !== -1;
      }
    },
    isFileImage() {
      return (file) => {
        if(file.task_file_mime === undefined) return false;
        return file.task_file_mime.indexOf("image/") !== -1;
      }
    },
    filePreviewLink() {
      return (file) => {
        if(file.task_file_id === undefined) return "";
        return `${window.baseUrl}task/files/${file.task_file_id}/preview`
      }
    }
  },
  mounted () {
    moment.locale("fr");
    this.$refs["scrollable-content"].scrollTo({
      top: this.$refs["scrollable-content"].scrollHeight
    })
  },
  methods: {
    async update() {
      if(this.historyToggled){
        this.historyToggled = false;
      }

      this.$nextTick(() => {
        this.$refs["quill-editor"].update();
        this.$refs["scrollable-content"].scrollTo({
          top: this.$refs["scrollable-content"].scrollHeight
        })
      })
    },
    toolClick(type) {
      switch(type){
        case "send":
          this.sendComment({
            content: this.$refs["comment-box"].getAsPlainText()
          });
          break;
        case "upload":
          this.$refs["task-file-upload"].click();
          break;
      }
    },
    triggerFileUploadClick() {
      this.$refs["task-file-upload"].click();
    },
    async handleFileUploadFromDrop(file) {
      let task_files = await this.uploadFiles([file]);
      if(this.isFileImage(task_files[0])){
        return this.fileAttachmentImage(task_files[0]);
      } else {
        return null;
      }
    },
    async handleFileUploadFromInput(ev) {
      let files = ev.target.files;
      await this.uploadFiles(files);
    },
    async fileDropHandler(ev) {
      let files = [];

      if (ev.dataTransfer.items) {
        for (var i = 0; i < ev.dataTransfer.items.length; i++) {
          if (ev.dataTransfer.items[i].kind === 'file') {
            files.push(ev.dataTransfer.items[i].getAsFile());
          }
        }
      } else {
        for (var i = 0; i < ev.dataTransfer.files.length; i++) {
          files.push(ev.dataTransfer.files);
        }
      }

      if(files.length > 0){
        await this.uploadFiles(files)
      }

    },
    async uploadFiles(files, task_comment_id = null) {
      let task_files = [];
      let task_id = this.task.task_id;

      console.log(task_id);

      for (const ix in files) {
        if(ix != "length" && ix != "item"){

          let task_file = {
            task_file_id: null,
            task_file_title: files[ix].name,
            task_file_attachment_datetime: null,
          }

          this.task.files.push(task_file);

          let formData = new FormData();
          formData.append(`file`, files[ix]);
          formData.append(`task_id`, task_id);
          if(task_comment_id != null){
            formData.append(`task_comment_id`, task_comment_id);
          }

          try {
            let response = await $.ajax({
              url: `${window.baseUrl}task/files/upload`,
              type: "POST",
              processData: false,
              contentType: false,
              dataType: "json",
              data: formData
            });

            task_file.task_file_id = response.task_file_id;
            task_file.task_file_attachment_datetime = response.task_file_attachment_datetime;
            task_file.task_file_mime = response.task_file_mime;

            toastr.success("Le fichier a été téléchargé avec succès.")

            task_files.push(task_file);
            this.task.file_count = this.task.files.length;
          } catch(err) {
            toastr.error(`Une erreur s'est produite lors du téléchargement du fichier "${task_file.task_file_title}".`)
            console.error(err);
          }

        }
      }

      return task_files;
    },
    async loadMoreHistory() {
      this.task.loaded_history_count += 10; 
      this.fetchHistory()
    },
    async loadMoreComments() {
      this.task.loaded_comment_count += 10; 
      this.fetchComments()
    },
    async fetchComments() {
      this.fetchingComments = true;

      let data = {
        filter_task_id: this.task.task_id,
        filter_page: 1,
        filter_by_page: this.task.loaded_comment_count ?? 10
      };

      try {
        let response = await $.post(`${window.baseUrl}task/comment/getjson`, {filters: Object.serialize(data), accept: "json"});
        this.task.comments.splice(0, this.task.comments.length, ...response.data);
        this.task.loaded_comment_count = this.task.comments.length;
        this.task.total_comments = this.task.comment_count = response.count;
      } catch(err) {
        toastr.error("Une erreur s'est produite lors de l'obtention des commentaires");
        console.error(err);
      }

      this.fetchingComments = false;
    },
    deleteCommentAsk(comment) {
      let that = this;

      bootbox.dialog({
        title: "Supprimer un commentaire",
        message: `Voulez-vous vraiment supprimer ce commentaire?`,
        buttons: {
          confirm: {
            label: "Supprimer",
            className: "red",
            callback: async function() {
              let result = await that.deleteComment(comment);
              return result;
            }
          },
          cancel: {
            label: "Annuler",
            className: "secondary",
            callback: function() {},
          }
        }
      })
    },
    async deleteComment(comment) {
      try {
        await $.post(`${window.baseUrl}task/comment/delete`, { id: comment.task_comment_id });
        let ix = this.task.comments.findIndex(c => c.task_comment_id == comment.task_comment_id);
        this.task.comments.splice(ix,1);
        this.task.comment_count--;
        this.$nextTick(() => {
          window.applyAdvancedFormatDetails();
        })
        return true;
      } catch(err) {
        toastr.error("Une erreur s'est produite lors de la suppression du commentaire.");
        console.error(err);
        return false;
      }
    },
    async fetchHistory() {
      this.fetchingHistory = true;

      let data = {
        filter_task_id: this.task.task_id,
        filter_page: 1,
        filter_by_page: this.task.loaded_history_count ?? 10
      };

      try {
        let response = await $.post(`${window.baseUrl}task/history/getjson`, {filters: Object.serialize(data), accept: "json"});
        this.task.history.splice(0, this.task.history.length, ...response.data);
        this.task.loaded_history_count = this.task.history.length;
        this.$nextTick(() => {
          window.applyAdvancedFormatDetails();
        })
      } catch(err) {
        toastr.error("Une erreur s'est produite lors de l'obtention de l'historique");
        console.error(err);
      }

      this.fetchingHistory = false;
    },
    downloadFile(file) {
      window.location.href = `${window.baseUrl}task/files/${file.task_file_id}/download`;
    },
    async deleteFileAsk(file, $event) {
      let that = this;

      if($event.ctrlKey) {
        await that.deleteFile(file);
      } else {
        bootbox.dialog({
          title: "Supprimer un fichier",
          message: `Voulez-vous vraiment supprimer le fichier ${file.task_file_title}`,
          buttons: {
            confirm: {
              label: "Supprimer",
              className: "red",
              callback: async function() {
                let result = await that.deleteFile(file);
                return result;
              }
            },
            cancel: {
              label: "Annuler",
              className: "secondary",
              callback: function() {},
            }
          }
        })
      }

    },
    async deleteFile(file) {
      try {
        await $.post(`${window.baseUrl}task/files/delete`, {task_file_id: file.task_file_id});
        let ix = this.task.files.findIndex(f => f.task_file_id == file.task_file_id);
        this.task.files.splice(ix, 1);
        this.task.file_count--;
      } catch(err) {
        toastr.error("Une erreur s'est produite lors de la suppression du fichier.");
        console.error(err);
      }
    },
    showSetCategorySelect(ev) {
      this.showSetCategoryContainer = true;
      this.$nextTick(() => {
        let rect = this.$refs["category-tag"].getBoundingClientRect();
        this.$refs["set-category-container"].style.top = (rect.top+25)+"px";
        this.$refs["set-category-container"].style.left = rect.left+"px";
      })
    },
    async changeTaskCategory(category) {
      this.task.task_category_id = category.task_category_id;
      this.task.task_category_background_color = category.task_category_background_color;
      this.task.task_category_font_color = category.task_category_font_color;
      this.task.task_category_name = category.task_category_name;

      this.showSetCategoryContainer = false;

      await this.saveTask();
    },
    showAddAssigneeSelect(ev) {
      this.showAddAssigneeContainer = true;
      this.$nextTick(() => {
        this.$refs["add-assignee-container"].style.top = ev.pageY+"px";
        this.$refs["add-assignee-container"].style.left = ev.pageX+"px";
        this.$refs["add-assignee-select"].focus();
      })
    },
    showAddDistributorSelect(ev) {
      this.showAddDistributorContainer = true;
      this.$nextTick(() => {
        this.$refs["add-distributor-container"].style.top = ev.pageY+"px";
        this.$refs["add-distributor-container"].style.left = ev.pageX+"px";
        this.$refs["add-distributor-select"].focus();
      })
    },
    async addAssigneeSelected(element, type) {

      let typeName = "";
      let collectionName = "";

      switch(type){
        case "assignee":
          typeName = "assignee";
          collectionName = "assignees";
          break;
        case "distributor":
          typeName = "distributor";
          collectionName = "distributors";
          break;
      }

      let newAssignee = {
        task_user_id: 0,
        user_name: element.text,
        user_background_color: element.color,
        user_initials: element.initials
      };

      this.task[collectionName].push(newAssignee)
      this.showAddAssigneeContainer = false;
      this.showAddDistributorContainer = false;

      try {
        let response = await $.post(`${window.baseUrl}task/${typeName}/assign`, {task_id: this.task.task_id, user_id: element.id});
        newAssignee.task_user_id = response.task_user_id;
      } catch(err) {
        toastr.error("Une erreur s'est produite lors de l'assignation de l'utilisateur à la tâche.");
        console.error(err);
      }
    },
    async unassignUser(assignee, type) {

      let typeName = "";
      let collectionName = "";

      switch(type){
        case "assignee":
          typeName = "assignee";
          collectionName = "assignees";
          break;
        case "distributor":
          typeName = "distributor";
          collectionName = "distributors";
          break;
      }

      let ix = this.task[collectionName].findIndex(a => a.task_user_id == assignee.task_user_id);
      try {
        let response = await $.post(`${window.baseUrl}task/${typeName}/unassign`, {id: assignee.task_user_id});
        this.task[collectionName].splice(ix, 1);
      } catch(err) {
        toastr.error("Une erreur s'est produite lors de la suppression de l'assignation.");
        console.error(err);
      }
    },
    toggleRead() {
      this.$emit("toggleread", this.task)
    },
    checkboxStateChange(ev) {
      this.task.task_state_id = ev.target.checked ? 2 : 1;
      let state = this.states.find(s => s.task_state_id == this.task.task_state_id);
      this.task.task_state_name = state.task_state_name;
      this.saveTask();
    },
    closeTask() {
      this.$emit("close");
    },
    sendComment(evt) {

      let comment = {
        user_id: this.user.user_id,
        user_name: this.user.user_name,
        user_initials: this.user.user_initials,
        user_background_color: this.user.user_background_color,
        task_comment_text: evt.content.trim(),
        task_comment_user_id: this.user.user_id,
        files: []
      };

      if(comment.task_comment_text == ""){
        return;
      }

      this.task.comment_count++;

      this.submitComment(comment);
    },
    async submitComment(comment) {

      let formData = new FormData();
      formData.append(`form`, Object.serialize({
        task_comment_text: comment.task_comment_text,
        task_comment_task_id: this.task.task_id,
      }));

      for(let index in comment.files) {
        formData.append(`file[${index}]`, comment.files[index]);
      }

      this.task.comments.unshift(comment);
      this.task.total_comments++;
      this.task.loaded_comment_count++;
      
      try {
        let result = await $.ajax({
          url: `${window.baseUrl}task/comment/create`,
          type: "POST",
          processData: false,
          contentType: false,
          dataType: "json",
          data: formData
        });

        let ix = this.task.comments.findIndex(m => m == comment);
        this.task.comments.splice(ix, 1, result);

        this.$refs["scrollable-content"].scrollTo({
          top: this.$refs["scrollable-content"].scrollHeight
        })
        
        window.applyAdvancedFormatDetails();
          
        setTimeout(() => {
          this.$refs["comment-box"].clear();
        }, 10);

      } catch(err) {
        toastr.error("Une erreur s'est produite lors de l'envoi du commentaire.");
        console.error(err);
      }
    },
    startDateChanged(){
      if(this.task.task_deadline_date == null || this.task.task_deadline_date == ""){
        this.task.task_deadline_date = this.task.task_start_date;
      }
      this.deadlineDateChanged();
    },
    deadlineDateChanged(){
      if(this.task.task_remind_date == null || this.task.task_remind_date == ""){
        this.task.task_remind_date = this.task.task_deadline_date;
      }
      this.saveTask();
    },
    async saveTask() {
      let data = {
        task_name: this.task.task_name,
        task_description: this.task.task_description,
        task_state_id: this.task.task_state_id,
        task_category_id: this.task.task_category_id,
        task_remind_date: this.task.task_remind_date,
        task_deadline_date: this.task.task_deadline_date,
        task_start_date: this.task.task_start_date,
        task_progress: this.task.task_progress,
      }

      let state = this.states.find(s => s.task_state_id == data.task_state_id);
      this.task.task_state_name = state.task_state_name;

      try {
        await $.post(`${window.baseUrl}task/edit/save`, {id: this.task.task_id, accept: "json", form: Object.serialize(data)});
      } catch(err) {
        toastr.error("Une erreur s'est produite lors de la sauvegarde des détails de la tâche.");
        console.error(err);
      }
    },
    deleteTaskAsk(){
      let that = this;

      bootbox.dialog({
        title: "Supprimer une tâche",
        message: `Voulez-vous vraiment supprimer ${this.task.task_name}`,
        buttons: {
          confirm: {
            label: "Confirmer",
            callback: async function() {
              let result = await that.deleteTask();
              return result;
            }
          } 
        }
      })
    },
    async deleteTask() {
      try {
        await $.post(`${window.baseUrl}task/remove`, { id: this.task.task_id, from: "tasks" });
        this.$emit("deleted", this.task);
        this.closeTask();
        toastr.success("La tâche a été supprimée avec succès!");
        return true;
      } catch(err) {
        toastr.error("Une erreur s'est produite lors de la suppression de la tâche");
        console.error(err);
        return false;
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.bottom-border {
  border-bottom: 1px solid #ccc;
}

.task-manager-files-section {
  border-top: 1px solid #ccc;
  padding: 5px 15px;
}

.task-manager-comment-section {
  border-top: 1px solid #ccc;

  .task-manager-comment {
    margin-top: 10px;
    display: flex;
    padding: 0 15px;

    .content-wrapper {
      border-radius: 5px;
      background-color: rgba(0,0,0,0.1);
    }

    .my-comment-actions {
      display: none;
    }

    &.my-comment {
      flex-direction: row-reverse;

      &:hover .my-comment-actions {
        display: block;
      }
    }
  }
}

.task-manager-compose-comment {
  padding: 2px 15px 10px;
  display: flex;
  align-items: top;

  textarea {
    resize: vertical;
    max-height: 100px;
  }
}

.avatar {
  border-radius: 100px;
  font-size: 18px;
  background-color: rgb(21, 89, 121);
  color: white;
  text-transform: uppercase;
  padding: 6px;
  height: 37px;
  min-width: 37px;
  width: 37px;
  text-align: center;
}

.form-control-title {
  border: none;
  border-bottom: 1px solid rgba(0,0,0,0);
  outline: none;

  &:hover {
    border-bottom: 1px solid #ccc;
  }
}

.task-assignee {
  display: inline-block;
  margin: 1px 3px 1px 0;
  padding: 4px 8px;
  border-radius: 25px;
  color: #fff;
  font-size: 12px;
  user-select: none;

  &:hover {
    background-image: linear-gradient(to top, rgba(255,255,255,0.1), rgba(255,255,255,0.1))
  }

  &.task-assignee-add {
    cursor: pointer;
    background-color: #ddd;
    color: black;
  }

  .task-assignee-delete {
    font-size: 14px !important;
    line-height: 12px !important;
    color: rgb(255, 60, 60);
  }
}

.task-manager-fixed-container {
  position: fixed;
  z-index: 50000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  &>div{
    position: absolute;
  }
}

.clickable {
  cursor: pointer;
  &:hover {
    background-image: linear-gradient(to right, rgba(0,0,0,0.1), rgba(0,0,0,0.1));
  }
}

.task-manager-file {
  padding: 5px 5px;
  display: flex;
  text-decoration: none;
  border-radius: 3px;
  cursor: pointer;
  margin: 0 -5px;

  .task-manager-file-thumbnail {
    width: 40px;
    height: 40px;
    min-width: 40px;
    object-fit: contain;
    margin-right: 5px;
  }

  &:hover {
    background-color: #ddd;
  }
}

.task-manager-wrapper {
  text-decoration: none;
}

</style>